<template>
  <div>
    <div class="card" :class="$style.container">
      <div class="text-dark font-size-24 mb-4">
        <strong>Reset Password</strong>
      </div>
      <a-form class="mb-4" :form="form">
        <a-form-item>
          <a-input
            size="large"
            v-model="email"
            placeholder="Email Address"
          />
          <p>{{response}}</p>
        </a-form-item>
        <a-button size="large" type="primary" class="text-center w-100" @click="resetPassword()">
          <strong>Reset my password</strong>
        </a-button>
      </a-form>
      <router-link to="/auth/login" class="kit__utils__link font-size-16">
        <i class="fe fe-arrow-left mr-1 align-middle" />
        Go to Sign in
      </router-link>
    </div>
  </div>
</template>
<script>
import { firebaseAuth } from '@/services/firebase'

export default {
  name: 'CuiForgotPassword',
  data: function () {
    return {
      form: this.$form.createForm(this),
      email: null,
      response: null,
    }
  },
  methods: {
    resetPassword() {
      firebaseAuth.sendPasswordResetEmail(this.email)
        .then(res => {
          this.response = ('Email has been sent to ' + this.email)
          this.email = null
        })
        .catch(error => {
          this.response = error.message
        })
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>
